import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class VariantProductFeatures extends Component {

  connectedCallback() {
    super.connectedCallback();

    this.section =
      this.closest('.shopify-section, dialog');

    if (!this.section) return;

    this.section.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }


  disconnectedCallback() {
    super.disconnectedCallback();

    if (!this.section) return;

    this.section.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }


  #handleProductSelect = (event) => {

    if (
      !(event.target instanceof Element) ||
      event.target.closest('product-card')
    ) {
      return;
    }

    if (!event.promise) return;


    event.promise
      .then(({ detail }) => {

        if (!detail?.html) return;


        /*
         * Ignore updates from another product.
         */
        if (
          detail.productId &&
          this.dataset.productId &&
          String(detail.productId) !==
            String(this.dataset.productId)
        ) {
          return;
        }


        const blockId =
          this.dataset.blockId;

        if (!blockId) return;


        /*
         * Find this same block in the HTML
         * Shopify rendered for the new variant.
         */
        const newFeatures =
          detail.html.querySelector(
            `variant-product-features[data-block-id="${blockId}"]`
          );

        if (!newFeatures) return;


        /*
         * Update each feature individually.
         */
        for (let i = 1; i <= 4; i++) {

          const currentItem =
            this.querySelector(
              `[data-feature-item="${i}"]`
            );

          const newItem =
            newFeatures.querySelector(
              `[data-feature-item="${i}"]`
            );

          if (!currentItem) continue;


          /*
           * If the newly rendered feature
           * doesn't exist, hide the current one.
           */
          if (!newItem) {

            currentItem.hidden = true;

            continue;
          }


          const currentText =
            currentItem.querySelector(
              `[data-feature-text="${i}"]`
            );

          const newText =
            newItem.querySelector(
              `[data-feature-text="${i}"]`
            );


          /*
           * Update text.
           */
          if (
            currentText &&
            newText &&
            newText.textContent.trim() !== ''
          ) {

            currentText.textContent =
              newText.textContent;

            currentText.hidden = false;

          } else if (currentText) {

            currentText.textContent = '';

            currentText.hidden = true;

          }


          /*
           * Copy visibility state rendered
           * by Liquid for the new variant.
           */
          currentItem.hidden =
            newItem.hidden;

        }

      })

      .catch((error) => {

        if (
          error?.name !== 'AbortError'
        ) {

          console.warn(
            '[variant-product-features] Event promise rejected:',
            error
          );

        }

      });

  };

}


if (
  !customElements.get(
    'variant-product-features'
  )
) {

  customElements.define(
    'variant-product-features',
    VariantProductFeatures
  );

}